import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import MarkChatUnreadRoundedIcon from "@mui/icons-material/MarkChatUnreadRounded";
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Fade,
    Paper,
    Popper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { IoMdNotifications } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useNotificationCenter } from "react-toastify/addons/use-notification-center";

const Notifications = () => {
    const { notifications, clear, markAsRead } =
        useNotificationCenter();
    const showUnreadOnly = false
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    // const [data,setData]=useEffect([])
    const [notData, setNotData] = useState([]);
    const [counts, setCounts] = useState([]);
    const storeId = localStorage.getItem("store_id")
    const navigate = useNavigate()

    // const addNotification = () => {
    //   // use a random type of notification
    //   toast("Good Day", {
    //     type: types[Math.floor(Math.random() * types.length)],
    //   });
    // };

    const toggleNotificationCenter = (event) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(!isOpen);
    };

    // const toggleFilter = () => {
    //   setShowUnreadOnly(!showUnreadOnly);
    // };

    // const notificationDataList = () => {
    //     axios
    //         .get(
    //             `https://mstore.bhaaraterp.com/api/admin/notification-list/?key=all&limit=&store_id=${storeId}`,
    //             {
    //                 headers: {
    //                     Token: localStorage.getItem("Token"),
    //                 },
    //             }
    //         )
    //         .then((response) => {
    //             console.log(
    //                 "notification data list===>",
    //                 response?.data?.notification_section_data
    //             );
    //             setNotData(response.data.inquiry_section_data);
    //             setCounts(response?.data?.count);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };
    // console.log("all count===>", counts);

    // useEffect(() => {
    //     notificationDataList();
    // }, []);


    const redirectPage = (event, subject) => {
        event.preventDefault()
        navigate("/order-management/customer-order")
    }

    return (
        <Box>
            {/* <IconButton
        className="!bg-white !bg-opacity-20"
        onClick={toggleNotificationCenter}
      >
        <img src={notification} alt="" className="!h-10" />
        <span className="text-[10px] px-1 border-2 border-white rounded-full relative right-5 top-[-15px] bg-red-600 text-white">
          {counts}
        </span>
      </IconButton> */}
            <div
                onClick={toggleNotificationCenter}
                className="w-12 p-1 px-2 flex justify-between rounded-full"
                style={{
                    background: "linear-gradient(135deg, #F261B7, #D05DEA)",
                }}
            >
                <IoMdNotifications className="!text-white" />
                <span className="text-white text-[12px]">{notData?.length ? notData?.length : "0"}</span>
            </div>

            <Popper
                open={isOpen}
                anchorEl={anchorEl}
                transition
                className="!-left-10 !z-50 !top-1 !w-[500px]"
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={100}>
                        <Box component={Paper}>
                            <div className="!p-0 bg-dark rounded-md">
                                <div className="flex items-center !p-2 justify-between">
                                    <p className="text-xl font-semibold tracking-wide">
                                        Notifications
                                    </p>
                                </div>
                                <div className="h-96 overflow-y-auto !p-1">
                                    <div>
                                        <TableContainer
                                            component={Paper}
                                            sx={{ width: "100%", maxHeight: 440 }}
                                            className="!text-black !mx-auto !bg-white overflow-auto px-2"
                                        >
                                            <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                                size="small"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            style={{
                                                                borderRight: "1px solid #D0D0D0",
                                                                fontFamily: "'Poppins', sans-serif",
                                                            }}
                                                            className="!text-center !text-gray-800 !font-bold"
                                                        >
                                                            DATE
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                borderRight: "1px solid #D0D0D0",
                                                                fontFamily: "'Poppins', sans-serif",
                                                            }}
                                                            className="!text-center !text-gray-800 !font-bold"
                                                        >
                                                            IMAGE
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                borderRight: "1px solid #D0D0D0",
                                                                fontFamily: "'Poppins', sans-serif",
                                                            }}
                                                            className="!text-center !text-gray-800 !font-bold"
                                                        >
                                                            SUBJECT
                                                        </TableCell>

                                                        <TableCell
                                                            style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                            }}
                                                            className="!text-center !text-gray-800 !font-bold"
                                                        >
                                                            DESCRIPTION
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {notData &&
                                                        notData.map((row) => (
                                                            <TableRow className="!cursor-pointer" onClick={(event) => redirectPage(event, row?.order_id)}>
                                                                <TableCell
                                                                    className="!text-center !text-[12px]"
                                                                    style={{
                                                                        borderRight: "1px solid #D0D0D0",
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                    }}
                                                                >
                                                                    {row?.date_time
                                                                        ? row?.date_time.slice(0, 10)
                                                                        : "--"}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="!text-center !text-[12px]"
                                                                    style={{
                                                                        borderRight: "1px solid #D0D0D0",
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                    }}
                                                                >
                                                                    {row?.image ? (
                                                                        <img src={row?.image} className="h-8 w-8" />
                                                                    ) : (
                                                                        "--"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="!text-center !text-[12px]"
                                                                    style={{
                                                                        borderRight: "1px solid #D0D0D0",
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                    }}
                                                                >
                                                                    {row?.subject ? row?.subject : "--"}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="!text-center !text-[12px]"
                                                                    style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                    }}
                                                                >
                                                                    {row?.message ? row?.message : "--"}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    {(showUnreadOnly
                                        ? notifications.filter((v) => !v.read)
                                        : notifications
                                    ).map((notification) => {
                                        return (
                                            <Alert
                                                className="!rounded-lg !capitalize !m-1 !px-2 flex items-center"
                                                severity={notification.type || "info"}
                                                onClick={() => markAsRead(notification.id)}
                                                action={
                                                    notification.read ? (
                                                        <MarkChatReadIcon className="!text-white mr-2" />
                                                    ) : (
                                                        <MarkChatUnreadRoundedIcon className="!text-white mr-2" />
                                                    )
                                                }
                                            >
                                                <AlertTitle className="!capitalize !font-semibold">
                                                    {notification.type}
                                                </AlertTitle>
                                                {notification.content}
                                            </Alert>
                                        );
                                    })}
                                </div>
                                <div className="flex !rounded-none border-t border-gray-400 !p-2 justify-between gap-2">
                                    <Button
                                        variant="contained"
                                        className="!text-xs !capitalize !bg-green-300"
                                        onClick={clear}
                                    >
                                        Clear All
                                    </Button>
                                    {/* <Button
                    variant="contained"
                    className="!text-xs !capitalize"
                    onClick={addNotification}
                  >
                    Add Notification
                  </Button> */}
                                    {/* <Button
                    variant="contained"
                    className="!text-xs !capitalize"
                    onClick={markAllAsRead}
                  >
                    Mark all as read
                  </Button> */}
                                </div>
                            </div>
                        </Box>
                    </Fade>
                )}
            </Popper>
        </Box>
    );
};

export default Notifications;